import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ServicesPage() {
  const { t } = useTranslation();

  const services = [
    {
      key: 'sprayFoam',
      icon: 'ri-window-line',
      image: 'https://storage.readdy-site.link/project_files/95272ccd-89f8-41e5-a90f-f2c2b48cc48a/0244d654-52ad-45f6-b864-55096b04d6f7_compressed_magnific_create-an-ultrarealistic-_XtMqM4ABfo.webp',
    },
    {
      key: 'battRoll',
      icon: 'ri-door-line',
      image: 'https://storage.readdy-site.link/project_files/95272ccd-89f8-41e5-a90f-f2c2b48cc48a/2ff86350-522f-4062-b257-5c3a38b8d17b_compressed_magnific_create-an-ultrarealistic-_nTZtZQbYQD.webp',
    },
    {
      key: 'cellulose',
      icon: 'ri-tools-line',
      image: 'https://storage.readdy-site.link/project_files/95272ccd-89f8-41e5-a90f-f2c2b48cc48a/0856088a-a6f0-4103-8dcb-63696ea332f1_compressed_WhatsApp-Image-2026-07-13-at-11.23.23-PM.webp',
    },
    {
      key: 'atticWall',
      icon: 'ri-home-4-line',
      image: 'https://storage.readdy-site.link/project_files/95272ccd-89f8-41e5-a90f-f2c2b48cc48a/03a35747-c098-4475-a5f1-696183d79ce4_compressed_WhatsApp-Image-2026-07-13-at-11.22.33-PM.webp',
    },
    {
      key: 'crawlSpace',
      icon: 'ri-arrow-left-right-line',
      image: 'https://storage.readdy-site.link/project_files/95272ccd-89f8-41e5-a90f-f2c2b48cc48a/536bf392-3d83-47b9-a1f6-e6d95a4fcd36_compressed_WhatsApp-Image-2026-07-13-at-11.22.41-PM.webp',
    },
    {
      key: 'metalBuilding',
      icon: 'ri-truck-line',
      image: 'https://storage.readdy-site.link/project_files/95272ccd-89f8-41e5-a90f-f2c2b48cc48a/6be02f1d-3079-4a59-ab1e-e705c8cac521_compressed_magnific_reframe-this-exact-photog_UyLGgAjwny.webp',
    },
  ];

  const areas = [
    { icon: 'ri-map-pin-line', key: 'area1' },
    { icon: 'ri-map-pin-line', key: 'area2' },
    { icon: 'ri-map-pin-line', key: 'area3' },
  ];

  return (
    <>
      <Navbar />
      <main>
        {/* Hero Banner */}
        <section className="relative w-full min-h-[360px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              alt="The Screen Squad screen services"
              className="w-full h-full object-cover object-center"
              src="https://storage.readdy-site.link/project_files/95272ccd-89f8-41e5-a90f-f2c2b48cc48a/6be02f1d-3079-4a59-ab1e-e705c8cac521_compressed_magnific_reframe-this-exact-photog_UyLGgAjwny.webp"
            />
            <div className="absolute inset-0 bg-black/60" />
          </div>
          <div className="relative z-10 text-center mt-12">
            <span className="inline-block bg-black/80 border-2 border-primary-500 text-white text-2xl md:text-4xl font-extrabold tracking-[0.15em] uppercase px-20 py-6 rounded-lg backdrop-blur-sm">
              {t('servicesPage.heroTitle')}
            </span>
          </div>
        </section>

        {/* Services Grid */}
        <section className="py-20 pb-5 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-14">
              <span className="text-primary-500 text-xs font-bold uppercase tracking-[0.25em]">{t('servicesPage.label')}</span>
              <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 mt-3">
                {t('servicesPage.title')}
              </h2>
              <p className="text-foreground-400 mt-4 text-sm max-w-2xl mx-auto">
                {t('servicesPage.description')}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {services.map((service, i) => (
                <div key={i} className="group bg-background-200 rounded-2xl overflow-hidden border border-white/5 hover:border-primary-500/40 transition-all duration-500">
                  <div className="relative w-full h-60 overflow-hidden">
                    <img
                      alt={t(`servicesPage.cards.${service.key}.title` as const)}
                      className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                      src={service.image}
                    />
                    {/* Hover overlay with request button */}
                    <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                      <Link
                        to="/contact"
                        className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white font-bold px-6 py-3 rounded-full text-sm transition-colors cursor-pointer flex items-center gap-2"
                      >
                        {t('servicesPage.requestService')}
                        <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center" />
                      </Link>
                    </div>
                    <div className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-primary-500 rounded-full">
                      <i className={`${service.icon} text-white text-lg w-6 h-6 flex items-center justify-center`} />
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-foreground-50 font-bold text-lg mb-3">
                      {t(`servicesPage.cards.${service.key}.title` as const)}
                    </h3>
                    <p className="text-foreground-400 text-sm leading-relaxed">
                      {t(`servicesPage.cards.${service.key}.desc` as const)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Service Areas */}
        <section className="pt-5 pb-10 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <span className="text-primary-500 text-xs font-bold uppercase tracking-[0.25em]">{t('servicesPage.areasLabel')}</span>
              <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 mt-3">
                {t('servicesPage.areasTitle')}
              </h2>
              <p className="text-foreground-400 mt-4 text-sm max-w-2xl mx-auto">
                {t('servicesPage.areasDesc')}
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {areas.map((area, i) => (
                <div key={i} className="bg-background-400/60 border border-primary-500/40 rounded-2xl p-8 text-center hover:border-primary-500/70 hover:bg-background-400/80 transition-all duration-300">
                  <div className="w-14 h-14 flex items-center justify-center bg-primary-500/15 rounded-full mx-auto mb-4">
                    <i className={`${area.icon} text-primary-500 text-2xl w-8 h-8 flex items-center justify-center`} />
                  </div>
                  <h3 className="text-foreground-50 font-bold text-lg mb-2">
                    {t(`servicesPage.${area.key}.title` as const)}
                  </h3>
                  <p className="text-foreground-400 text-sm leading-relaxed">
                    {t(`servicesPage.${area.key}.desc` as const)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0">
            <img
              alt="Screen installation project"
              className="w-full h-full object-cover object-center"
              src="https://storage.readdy-site.link/project_files/95272ccd-89f8-41e5-a90f-f2c2b48cc48a/696abc18-c46e-42f5-8b40-ec4c7f1f3b60_compressed_magnific_create-an-ultrarealistic-_xg565cOjfW.webp"
            />
            <div className="absolute inset-0 bg-black/70" />
          </div>
          <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
              {t('servicesPage.finalCta')}
            </h2>
            <p className="text-white/70 text-base max-w-xl mx-auto mb-8">
              {t('servicesPage.finalCtaDesc')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white font-bold px-10 py-4 rounded-full text-sm transition-colors cursor-pointer flex items-center justify-center gap-2"
              >
                {t('ctaBanner.quoteBtn')}
                <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center" />
              </Link>
              <a
                href="tel:+16574338533"
                className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white font-bold px-10 py-4 rounded-full text-sm transition-colors cursor-pointer flex items-center justify-center gap-2"
              >
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center" />
                {t('nav.phone')}
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}